export default "__VITE_ASSET__BMnVCrKU__"